import { messagesForLocale, toIntlLocale, type Locale, type MonthStyle } from "../i18n";

const publicationDateFormatters = new Map<string, Intl.DateTimeFormat>();

function publicationDateFormatter(
  locale: Locale,
  month: MonthStyle
): Intl.DateTimeFormat {
  const key = `${locale}:${month}`;
  const existing = publicationDateFormatters.get(key);
  if (existing) {
    return existing;
  }

  const formatter = new Intl.DateTimeFormat(toIntlLocale(locale), {
    day: "numeric",
    month,
    year: "numeric",
    timeZone: "UTC"
  });
  publicationDateFormatters.set(key, formatter);
  return formatter;
}

export function formatPublicationDate(
  value: string,
  month: MonthStyle = "long",
  locale: Locale = "en"
): string {
  const parsed = new Date(value.includes("T") ? value : `${value}T00:00:00Z`);

  if (Number.isNaN(parsed.getTime())) {
    return messagesForLocale(locale).dates.unavailable;
  }

  return publicationDateFormatter(locale, month).format(parsed);
}
